import z from 'zod'

export const imageTypeSchema = z.templateLiteral([
  'image/',
  z.union([z.literal('png'), z.literal('jpeg'), z.literal('jpg')]),
])

export const documentTypeSchema = z.literal('application/pdf')
export const fileTypeSchema = z.union([imageTypeSchema, documentTypeSchema])

export type ImageType = z.infer<typeof imageTypeSchema>
export type DocumentType = z.infer<typeof documentTypeSchema>
export type FileType = z.infer<typeof fileTypeSchema>

export const uploadFileSchema = z.object({
  arrayBuffer: z.instanceof(ArrayBuffer),
  path: z.string(),
  name: z.string(),
  type: fileTypeSchema,
  size: z.number().optional(),
})

export type UploadFile = z.infer<typeof uploadFileSchema>
